"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import GradientButton from "@/components/ui/GradientButton";
import { FaChevronRight } from "react-icons/fa";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
export default function CrmBanner() {
  const $ = _c(31);
  const desktopAnimations = useDesktopAnimations();
  let t0;
  if ($[0] !== desktopAnimations) {
    t0 = desktopAnimations ? {
      opacity: 0,
      x: -30
    } : false;
    $[0] = desktopAnimations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== desktopAnimations) {
    t1 = desktopAnimations ? {
      opacity: 1,
      x: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== desktopAnimations) {
    t2 = desktopAnimations ? undefined : {
      opacity: 1,
      x: 0
    };
    $[4] = desktopAnimations;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      duration: 0.6,
      ease
    };
    t4 = {
      once: true
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h3 className="font-poppins text-lg sm:text-xl lg:text-[22px] font-bold text-[#0b1354] dark:text-pink-400 mb-3 tracking-tight">Build Your On-Demand Home Service App</h3>;
    t6 = <h2 className="font-poppins text-2xl sm:text-3xl lg:text-[38px] font-bold text-[#0b1354] dark:text-white leading-[1.25] mb-8 tracking-tight max-w-xl">Looking for expert developers to bring your home service app to life?</h2>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <GradientButton href="/contact" variant="peach-pink">I Want to Build My Home Service App <FaChevronRight className="ml-1 text-[12px]" /></GradientButton>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t0 || $[12] !== t1 || $[13] !== t2) {
    t8 = <motion.div initial={t0} whileInView={t1} animate={t2} transition={t3} viewport={t4} className="lg:col-span-7 flex flex-col items-start z-10">{t5}{t6}{t7}</motion.div>;
    $[11] = t0;
    $[12] = t1;
    $[13] = t2;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== desktopAnimations) {
    t9 = desktopAnimations ? {
      opacity: 0,
      x: 30
    } : false;
    $[15] = desktopAnimations;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== desktopAnimations) {
    t10 = desktopAnimations ? {
      opacity: 1,
      x: 0
    } : undefined;
    $[17] = desktopAnimations;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== desktopAnimations) {
    t11 = desktopAnimations ? undefined : {
      opacity: 1,
      x: 0
    };
    $[19] = desktopAnimations;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      duration: 0.6,
      ease
    };
    t13 = {
      once: true
    };
    $[21] = t12;
    $[22] = t13;
  } else {
    t12 = $[21];
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Image src="/images/multi-vendor/images/service-build-app.png" alt="Developer working on home service app" width={480} height={400} className="w-full max-w-[420px] lg:max-w-[480px] h-auto object-contain drop-shadow-md" />;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t9) {
    t15 = <motion.div initial={t9} whileInView={t10} animate={t11} transition={t12} viewport={t13} className="lg:col-span-5 flex justify-center items-center z-10">{t14}</motion.div>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t9;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t15 || $[29] !== t8) {
    t16 = <section className="bg-white dark:bg-gray-950 py-12 md:py-16 px-4 sm:px-6 lg:px-8 font-sans"><div className="max-w-7xl mx-auto"><div className="relative bg-gradient-to-b from-[#c7ecff] to-[#f9efff] dark:from-gray-900 dark:to-gray-800/90 dark:border dark:border-gray-800 rounded-2xl p-8 sm:p-12 lg:p-14 overflow-hidden shadow-sm"><div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">{t8}{t15}</div></div></div></section>;
    $[28] = t15;
    $[29] = t8;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  return t16;
}